import { render } from "./AppFooter.vue?vue&type=template&id=67e17082&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-67e17082"

export default script